export const PREVIEW = 'preview';
export const PROCESSING = 'processing';
export const DONE = 'done';
export const FAILED = 'failed';
export const COMPLETE = 'complete';